import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Navbar from './landing/Navbar';
import HeroSection from './landing/HeroSection';
import SocialProofBar from './landing/SocialProofBar';
import FeaturesSection from './landing/FeaturesSection';
import HowItWorksSection from './landing/HowItWorksSection';
import PricingSection from './landing/PricingSection';
import FinalCTASection from './landing/FinalCTASection';
import Footer from './landing/Footer';

const Home: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard/home', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const googleLoginUrl = `${process.env.REACT_APP_API_URL}/auth/google`;
  const handleSignIn = () => {
    window.location.href = googleLoginUrl;
  };

  if (isAuthenticated) return null;

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>InstantExam — Create AI-Powered Exams in Seconds</title>
        <meta name="description" content="Create, share, and score exams instantly with AI. Generate quizzes from any topic, PDF, URL, or YouTube video. No student signup required. Free to start." />
        <meta property="og:title" content="InstantExam — AI-Powered Exam Creator for Teachers & Trainers" />
        <meta property="og:description" content="Generate professional exams in seconds from any content. Real-time scoring, leaderboards, and analytics. Used by educators worldwide." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://instantexam.co" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="InstantExam — Create AI-Powered Exams in Seconds" />
        <meta name="twitter:description" content="Generate professional exams in seconds from any content. Real-time scoring, leaderboards, and analytics." />
        <link rel="canonical" href="https://instantexam.co" />
      </Helmet>
      <Navbar onSignIn={handleSignIn} />
      <HeroSection onGetStarted={handleSignIn} />
      <SocialProofBar />
      <FeaturesSection />
      <HowItWorksSection />
      <PricingSection onGetStarted={handleSignIn} />
      <FinalCTASection onGetStarted={handleSignIn} />
      <Footer />
    </div>
  );
};

export default Home;
